<template>
  <!-- Nigeria-->
  <div id="nigeriaForm" class="form_bottom_row line clearfix">
    <div class="fl form_row">
      <el-form :model="TransferForm" ref="TransferForm" :rules="NigeriaFormRules">
        <ul class="form_list clearfix">
          <li class="fl">
            <SelectForm
              v-model="TransferForm.selectedCardID"
              :label="$t('withdraw.default.selectBA')"
              name="selectedCardID"
              testId="selectedCardID"
            >
              <el-option
                v-for="item in availableCards"
                :key="item.id"
                :value="item.id"
                :label="item.id | cardInfoDropdown(item, withdrawalType)"
                :data-testid="`select_${item.id}`"
              ></el-option>
            </SelectForm>
          </li>
        </ul>
        <div v-if="TransferForm.selectedCardID || TransferForm.selectedCardID === 0">
          <ul class="form_list clearfix">
            <li>
              <InputForm
                :label="$t('common.field.bankName')"
                name="bankName"
                v-model="TransferForm.bankName"
                :disabled="isdisabled"
              ></InputForm>
            </li>
            <li>
              <InputForm
                :label="$t('common.field.bankAddress')"
                name="bankAddress"
                v-model="TransferForm.bankAddress"
                :disabled="isdisabled"
              ></InputForm>
            </li>
            <li>
              <InputForm
                :label="$t('common.field.bankAccName')"
                name="bankAccName"
                v-model="TransferForm.bankAccName"
                :disabled="isdisabled"
              ></InputForm>
            </li>
            <li>
              <InputForm
                :label="$t('common.field.bankAccNum')"
                name="accountNumber"
                v-model.trim="TransferForm.accountNumber"
                :disabled="isdisabled"
              ></InputForm>
            </li>
            <li>
              <InputForm
                :label="$t('common.field.bankBranchCode')"
                name="bankBranchCode"
                v-model.trim="TransferForm.bankBranchCode"
                :disabled="isdisabled"
              ></InputForm>
            </li>
            <li>
              <InputForm
                :label="$t('common.field.phone')"
                name="telephoneNumber"
                v-model.trim="TransferForm.telephoneNumber"
                :disabled="isdisabled"
              ></InputForm>
            </li>
            <li>
              <InputForm
                :label="$t('common.field.email')"
                name="email"
                v-model.trim="TransferForm.email"
                :disabled="isdisabled"
              ></InputForm>
            </li>
            <li>
              <ImportantNotesInput
                :label="$t('common.field.imptNotes')"
                name="importantNotes"
                v-model="TransferForm.impNotes"
              ></ImportantNotesInput>
            </li>
            <li class="fr data">
              <p>
                {{
                  $t('deposit.default.rate.rate', {
                    oldCurrency: this.accountCurrency,
                    newCurrency: this.form.depositCurrency
                  })
                }}<span>{{ rate }}</span>
              </p>
            </li>
          </ul>

          <p class="mb-2 text_red">
            {{ $t('withdraw.LBTchannelsNote') }}
          </p>

          <div class="checkbox_wrapper" v-if="!TransferForm.userPaymentInfoId">
            <el-checkbox v-model="isRememberInfo" data-testid="rememberInfo">
              {{ $t('withdraw.default.remember') }}</el-checkbox
            >
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import withdrawlMixin from '@/mixins/withdrawl/withdrawl';
import bankTransferMixin from '@/mixins/withdrawl/bankTransfer';
import { apiQueryRate_USD_NGN } from '@/resource';
import { alphaNumericFormatter } from '@/util/inputFormatter';
import { validateEmail } from '@/util/validation';
import ImportantNotesInput from '@/components/form/ImportantNotesInput';

export default {
  name: 'NigeriaWithdraw',
  props: ['accountNumber', 'amount', 'withdrawalType'],
  components: { ImportantNotesInput },
  mixins: [bankTransferMixin, withdrawlMixin],
  data() {
    return {
      accountCurrency: 'USD',
      rateChange: 0,
      rate: 0,
      form: {
        depositCurrency: 'NGN'
      },
      minLimit: 30,
      TransferForm: {
        bankName: '',
        bankAddress: '',
        bankAccName: '',
        accountNumber: '',
        bankBranchCode: '',
        telephoneNumber: '',
        email: '',
        importantNotes: '',
        userPaymentInfoId: null
      },
      NigeriaFormRules: {
        selectedCardID: [
          {
            required: true,
            message: this.$t('common.formValidation.selectBAReq'),
            trigger: 'blur'
          }
        ],
        bankName: [
          {
            required: true,
            message: this.$t('common.formValidation.bankNameReq'),
            trigger: 'blur'
          }
        ],
        bankAddress: [
          {
            required: true,
            message: this.$t('common.formValidation.bankAddressReq'),
            trigger: 'blur'
          }
        ],
        bankAccName: [
          {
            required: true,
            message: this.$t('common.formValidation.accNameReq'),
            trigger: 'blur'
          }
        ],
        accountNumber: [
          {
            required: true,
            validator: this.validateAccount,
            trigger: ['blur', 'change']
          }
        ],
        bankBranchCode: [
          {
            required: true,
            message: this.$t('common.formValidation.bankBranchCodeReq'),
            trigger: 'blur'
          }
        ],
        telephoneNumber: [
          {
            required: true,
            message: this.$t('common.formValidation.phoneNumberReq'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: this.$t('common.formValidation.dynamicReq', {
              dynamic: this.$t('common.field.email')
            }),
            trigger: 'blur'
          },
          {
            validator: validateEmail,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    getFormData() {
      return {
        qAccount: this.accountNumber,
        amount: this.amount,
        withdrawalType: this.withdrawalType,
        bankName: this.TransferForm.bankName,
        bankAddress: this.TransferForm.bankAddress,
        bankAccountName: this.TransferForm.bankAccName,
        accountNumber: this.TransferForm.accountNumber,
        branchCode: this.TransferForm.bankBranchCode,
        phoneNumber: this.TransferForm.telephoneNumber,
        email: this.TransferForm.email,
        importantNotes: this.TransferForm.importantNotes,
        isRememberInfo: this.TransferForm.userPaymentInfoId ? '' : this.isRememberInfo,
        userPaymentInfoId: this.TransferForm.userPaymentInfoId ? this.TransferForm.userPaymentInfoId : ''
      };
    },
    queryRate() {
      apiQueryRate_USD_NGN()
        .then(resp => {
          if (resp.data.code == 0) this.rate = resp.data.data;
        })
        .catch(err => {
          this.errorMessage(
            this.$t('deposit.default.rate.result.rateError', { oldCurrency: 'USD', newCurrency: 'INR' })
          );
        });
    }
  },
  watch: {
    'TransferForm.selectedCardID'(value) {
      let selectedCardInfo = this.availableCards.find(item => item.id === value);
      let isCurrentCard = selectedCardInfo && selectedCardInfo.id !== -1;
      this.TransferForm = {
        selectedCardID: value,
        bankName: isCurrentCard ? selectedCardInfo.bankName : '',
        bankAccName: isCurrentCard ? selectedCardInfo.bankAccountName : '',
        bankAddress: isCurrentCard ? selectedCardInfo.bankAddress : '',
        accountNumber: isCurrentCard ? selectedCardInfo.accountNumber : '',
        bankBranchCode: isCurrentCard ? selectedCardInfo.branchCode : '',
        telephoneNumber: isCurrentCard ? selectedCardInfo.phoneNumber : '',
        email: isCurrentCard ? selectedCardInfo.email : '',
        importantNotes: isCurrentCard ? selectedCardInfo.importantNotes : '',
        userPaymentInfoId: isCurrentCard ? selectedCardInfo.id : null
      };
      this.isdisabled = isCurrentCard ? true : false;
    },
    'TransferForm.accountNumber'(value) {
      this.TransferForm.accountNumber = alphaNumericFormatter(value);
    }
  },
  mounted() {
    this.queryRate();
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/components/withdraw/method.scss';
</style>
